/* ============================================================
   SPARC MOBILE SERIES V1
   NON-MUSCLE MOBILE CONFIGURATOR
   FIXED DRIVER BASELINE

   SUPPORTED:
   - Driver Series
   - Heritage Series
   - Classic 3100
   - Classic Squarebody
   - Garage Series
   - Muscle Round

   IMPORTANT:
   - DOES NOT target #sparc-muscle-configurator
   - DOES NOT modify Muscle Mobile V4
   - DOES NOT move the real configurator
   - DOES NOT interfere with hidden Hulk controls
   ============================================================ */

(function () {
  "use strict";


  if (window.__SPARC_MOBILE_SERIES_V1__) {
    return;
  }

  window.__SPARC_MOBILE_SERIES_V1__ = true;


  /* ==========================================================
     SUPPORTED SERIES
     ========================================================== */

  var SERIES = {
    "sparc-driver-configurator": {
      name: "Driver Series"
    },

    "sparc-heritage-configurator": {
      name: "Heritage Series"
    },

    "sparc-classic-3100-configurator": {
      name: "Classic 3100"
    },

    "sparc-classic-squarebody-configurator": {
      name: "Classic Squarebody"
    },

    "sparc-garage-configurator": {
      name: "Garage Series"
    },

    "sparc-muscle-round-configurator": {
      name: "Muscle Series"
    }
  };


  var PANEL_IDS =
    Object.keys(SERIES);


  /* ==========================================================
     STATE
     ========================================================== */

  var panel = null;

  var appbar = null;
  var hero = null;
  var dock = null;
  var descriptionView = null;

  var syncTimer = null;
  var syncInterval = null;

  var eventsInstalled = false;
  var syncing = false;

  var configScrollPosition = 0;

  var lastPrice = "";
  var lastLead = "";

  var firstValueSync = true;


  /* ==========================================================
     HELPERS
     ========================================================== */

  function q(selector, root) {
    return (
      root ||
      document
    ).querySelector(
      selector
    );
  }


  function qa(selector, root) {
    return Array.prototype.slice.call(
      (
        root ||
        document
      ).querySelectorAll(
        selector
      )
    );
  }


  function clean(value) {
    return String(
      value ||
      ""
    )
      .replace(
        /\u00a0/g,
        " "
      )
      .replace(
        /\s+/g,
        " "
      )
      .trim();
  }


  function normalize(value) {
    return clean(
      value
    )
      .toLowerCase()
      .replace(
        /[^a-z0-9]+/g,
        ""
      );
  }


  function make(
    tag,
    className,
    text
  ) {
    var node =
      document.createElement(
        tag
      );

    if (className) {
      node.className =
        className;
    }

    if (
      text !==
      undefined
    ) {
      node.textContent =
        text;
    }

    return node;
  }


  function isPhone() {
    var narrow =
      window.matchMedia &&
      window.matchMedia(
        "(max-width: 767px)"
      ).matches;

    var phoneUA =
      /iPhone|iPod|Android.*Mobile|Windows Phone/i
        .test(
          navigator.userAgent ||
          ""
        );

    return (
      narrow ||
      phoneUA
    );
  }


  /* ==========================================================
     FIND ACTIVE CONFIGURATOR
     ========================================================== */

  function getPanel() {
    for (
      var i = 0;
      i < PANEL_IDS.length;
      i++
    ) {
      var candidate =
        document.getElementById(
          PANEL_IDS[i]
        );

      if (
        candidate &&
        q(
          ".sparc-accordion-list",
          candidate
        ) &&
        q(
          ".sparc-accordion[data-section]",
          candidate
        )
      ) {
        return candidate;
      }
    }

    return null;
  }


  /* ==========================================================
     SERIES
     ========================================================== */

  function currentSeriesName() {
    if (
      !panel ||
      !SERIES[
        panel.id
      ]
    ) {
      return "Steering Wheels";
    }

    return SERIES[
      panel.id
    ].name;
  }


  function findSeriesLink() {
    var target =
      normalize(
        currentSeriesName()
      );


    return qa(
      "a"
    ).find(
      function (node) {
        var href =
          node.getAttribute(
            "href"
          );

        return (
          href &&
          normalize(
            node.textContent
          ) ===
          target
        );
      }
    ) || null;
  }


  function seriesHref() {
    var link =
      findSeriesLink();

    if (
      link &&
      link.getAttribute(
        "href"
      )
    ) {
      return link.getAttribute(
        "href"
      );
    }

    return "";
  }


  /* ==========================================================
     PRODUCT NAME
     ========================================================== */

  function productName() {
    if (panel) {
      var build =
        q(
          ".sparc-build-title",
          panel
        );

      var buildText =
        clean(
          build &&
          build.textContent
        );

      if (buildText) {
        buildText =
          buildText.replace(
            /^build\s+your\s+/i,
            ""
          );

        if (buildText) {
          return buildText;
        }
      }
    }


    var title =
      q(
        "#ProductSection h1.product-single__title"
      )
      ||
      q(
        "h1.product-single__title"
      )
      ||
      q(
        ".product__title h1"
      )
      ||
      q(
        "main h1"
      );


    return (
      clean(
        title &&
        title.textContent
      )
      ||
      "Steering Wheel"
    );
  }


  /* ==========================================================
     SECTION ORDER
     ========================================================== */

  function sectionIsVisible(node) {
    if (!node) {
      return false;
    }

    if (
      node.hidden ||
      node.getAttribute(
        "aria-hidden"
      ) ===
      "true"
    ) {
      return false;
    }


    var style =
      window.getComputedStyle(
        node
      );


    return (
      style.display !==
      "none"
      &&
      style.visibility !==
      "hidden"
    );
  }


  function orderedSections() {
    if (!panel) {
      return [];
    }

    return qa(
      ".sparc-accordion[data-section]",
      panel
    ).filter(
      sectionIsVisible
    );
  }


  function currentSection() {
    var sections =
      orderedSections();


    var open =
      sections.find(
        function (node) {
          return (
            node.classList.contains(
              "is-open"
            )
            ||
            node.getAttribute(
              "aria-expanded"
            ) ===
            "true"
          );
        }
      );


    return (
      open ||
      sections[0] ||
      null
    );
  }


  function nextSection() {
    var sections =
      orderedSections();

    var current =
      currentSection();


    if (
      !current ||
      !sections.length
    ) {
      return null;
    }


    var index =
      sections.indexOf(
        current
      );


    if (
      index < 0 ||
      index >=
      sections.length - 1
    ) {
      return null;
    }


    return sections[
      index + 1
    ];
  }


  function currentIsFinal() {
    var sections =
      orderedSections();

    var current =
      currentSection();


    if (
      !current ||
      !sections.length
    ) {
      return false;
    }


    if (
      current.dataset &&
      current.dataset.section ===
      "summary"
    ) {
      return true;
    }


    return (
      sections[
        sections.length - 1
      ] ===
      current
    );
  }


  /* ==========================================================
     PRICE
     ========================================================== */

  function priceFromText(text) {
    text =
      clean(
        text
      );


    var matches =
      text.match(
        /Total price is\s*\$[\d,]+(?:\.\d{2})?/ig
      );


    if (
      !matches ||
      !matches.length
    ) {
      return "";
    }


    var last =
      matches[
        matches.length - 1
      ];


    var money =
      last.match(
        /\$[\d,]+(?:\.\d{2})?/
      );


    return money
      ?
      money[0]
      :
      "";
  }


  function configuredPrice() {
    /*
      Prefer the existing SPARC configured price.
    */

    if (panel) {
      var desktopPrice =
        q(
          "#sparc-config-price",
          panel
        );


      var desktopText =
        clean(
          desktopPrice &&
          desktopPrice.textContent
        );


      var desktopMoney =
        desktopText.match(
          /\$[\d,]+(?:\.\d{2})?/
        );


      if (desktopMoney) {
        return desktopMoney[0];
      }
    }


    /*
      Hulk price source.
    */

    var direct =
      priceFromText(
        document.body.textContent ||
        ""
      );


    if (direct) {
      return direct;
    }


    var visible =
      priceFromText(
        document.body.innerText ||
        ""
      );


    if (visible) {
      return visible;
    }


    /*
      Shopify product-price fallback.
    */

    var selectors = [
      "#ProductPrice",
      ".product-single__price",
      ".product__price",
      "[data-product-price]",
      '[itemprop="price"]'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var node =
        q(
          selectors[i]
        );


      if (!node) {
        continue;
      }


      var text =
        clean(
          node.textContent
          ||
          (
            node.getAttribute &&
            node.getAttribute(
              "content"
            )
          )
        );


      var money =
        text.match(
          /\$[\d,]+(?:\.\d{2})?/
        );


      if (money) {
        return money[0];
      }
    }


    return "—";
  }


  /* ==========================================================
     LEAD TIME
     ========================================================== */

  function leadText() {
    if (!panel) {
      return "—";
    }


    var node =
      q(
        "#sparc-config-lead",
        panel
      );


    var value =
      clean(
        node &&
        node.textContent
      );


    return (
      value ||
      "—"
    );
  }


  /* ==========================================================
     SITE LOGO
     ========================================================== */

  function findLogoNode() {
    var selectors = [
      "#shopify-section-header .site-header__logo-image img",
      ".site-header__logo-image img",
      "header img.header__heading-logo",
      "header .header__heading-logo",
      'header [class*="logo"] img',
      'header img[alt*="SPARC" i]',
      '#shopify-section-header img[alt*="SPARC" i]',
      'header [class*="logo"] svg'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var node =
        q(
          selectors[i]
        );

      if (node) {
        return node;
      }
    }


    return null;
  }


  function buildLogoClone() {
    var holder =
      make(
        "div",
        "sparc-mobile-appbar__brand"
      );


    var source =
      findLogoNode();


    if (!source) {
      return holder;
    }


    var clone =
      source.cloneNode(
        true
      );


    clone.removeAttribute(
      "id"
    );


    if (
      clone.tagName &&
      clone.tagName
        .toLowerCase() ===
      "img"
    ) {
      clone.removeAttribute(
        "width"
      );

      clone.removeAttribute(
        "height"
      );

      clone.className =
        "sparc-mobile-appbar__logo-img";
    } else {
      clone.classList.add(
        "sparc-mobile-appbar__logo-svg"
      );
    }


    holder.appendChild(
      clone
    );


    return holder;
  }


  /* ==========================================================
     HERO IMAGE
     ========================================================== */

  function findHeroImage() {
    var selectors = [
      "#ProductSection .product-single__featured-image-wrapper img",
      "#ProductSection .product-single__photo img",
      "#ProductSection img.product-single__photo",
      "#ProductSection .product__media img",
      ".product-single__featured-image-wrapper img",
      ".product-single__photo img"
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var nodes =
        qa(
          selectors[i]
        );


      for (
        var j = 0;
        j < nodes.length;
        j++
      ) {
        var node =
          nodes[j];


        if (
          node &&
          (
            node.currentSrc ||
            node.src
          )
        ) {
          return node;
        }
      }
    }


    return null;
  }


  /* ==========================================================
     PRODUCT DESCRIPTION
     ========================================================== */

  function findDescriptionSource() {
    var selectors = [
      "#ProductDescription",
      ".product-single__description",
      ".product__description",
      ".product-description",
      '[itemprop="description"]',
      "#ProductSection .rte.product-single__description",
      "#ProductSection .rte"
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var nodes =
        qa(
          selectors[i]
        );


      for (
        var j = 0;
        j < nodes.length;
        j++
      ) {
        var node =
          nodes[j];


        if (
          panel &&
          panel.contains(
            node
          )
        ) {
          continue;
        }


        if (
          clean(
            node.textContent
          ).length >=
          25
        ) {
          return node;
        }
      }
    }


    return null;
  }


  /* ==========================================================
     ANCESTOR SAFETY
     ========================================================== */

  function markAncestors() {
    if (!panel) {
      return;
    }


    var parent =
      panel.parentElement;


    while (
      parent &&
      parent !==
      document.body
    ) {
      parent.classList.add(
        "sparc-mobile-app-ancestor"
      );


      parent =
        parent.parentElement;
    }
  }


  /* ==========================================================
     CART ICON
     ========================================================== */

  function cartIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true">',
      '<path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.4L21 8H7"></path>',
      '<circle cx="10" cy="20" r="1"></circle>',
      '<circle cx="18" cy="20" r="1"></circle>',
      "</svg>"
    ].join("");
  }


  /* ==========================================================
     APP BAR
     ========================================================== */

  function ensureAppBar() {
    var existing =
      q(
        ".sparc-mobile-appbar",
        panel
      );


    if (existing) {
      appbar =
        existing;

      return appbar;
    }


    appbar =
      make(
        "div",
        "sparc-mobile-appbar"
      );


    var left =
      make(
        "div",
        "sparc-mobile-appbar__left"
      );


    var back =
      make(
        "button",
        "sparc-mobile-appbar__back",
        "‹"
      );


    back.type =
      "button";


    back.setAttribute(
      "aria-label",
      "Back"
    );


    back.addEventListener(
      "click",
      function () {
        if (
          window.history.length >
          1
        ) {
          window.history.back();
          return;
        }


        var href =
          seriesHref();


        window.location.href =
          href ||
          "/";
      }
    );


    var details =
      make(
        "button",
        "sparc-mobile-appbar__mode",
        "DETAILS"
      );


    details.type =
      "button";


    details.addEventListener(
      "click",
      toggleMode
    );


    left.appendChild(
      back
    );


    left.appendChild(
      details
    );


    var brand =
      buildLogoClone();


    var right =
      make(
        "div",
        "sparc-mobile-appbar__right"
      );


    var cart =
      make(
        "button",
        "sparc-mobile-cart-button"
      );


    cart.type =
      "button";


    cart.setAttribute(
      "aria-label",
      "Cart"
    );


    cart.innerHTML =
      cartIcon();


    var badge =
      make(
        "span",
        "sparc-mobile-cart-count is-empty",
        "0"
      );


    cart.appendChild(
      badge
    );


    cart.addEventListener(
      "click",
      function () {
        window.location.href =
          "/cart";
      }
    );


    right.appendChild(
      cart
    );


    appbar.appendChild(
      left
    );


    appbar.appendChild(
      brand
    );


    appbar.appendChild(
      right
    );


    panel.insertBefore(
      appbar,
      panel.firstChild
    );


    return appbar;
  }


  /* ==========================================================
     CART COUNT
     ========================================================== */

  function findCartCount() {
    var selectors = [
      "[data-cart-count]",
      ".cart-count-bubble",
      ".site-header__cart-count",
      ".cart-link__bubble-num",
      ".header__cart-count",
      '[class*="cart-count"]'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var nodes =
        qa(
          selectors[i]
        );


      for (
        var j = 0;
        j < nodes.length;
        j++
      ) {
        var node =
          nodes[j];


        if (
          node.closest &&
          node.closest(
            ".sparc-mobile-appbar"
          )
        ) {
          continue;
        }


        var match =
          clean(
            node.textContent
          ).match(
            /\d+/
          );


        if (match) {
          return parseInt(
            match[0],
            10
          );
        }
      }
    }


    return 0;
  }


  function updateCartCount() {
    if (!appbar) {
      return;
    }


    var badge =
      q(
        ".sparc-mobile-cart-count",
        appbar
      );


    if (!badge) {
      return;
    }


    var count =
      findCartCount();


    var text =
      String(
        count
      );


    if (
      badge.textContent !==
      text
    ) {
      badge.textContent =
        text;
    }


    badge.classList.toggle(
      "is-empty",
      count <=
      0
    );
  }


  /* ==========================================================
     HERO
     ========================================================== */

  function ensureHero() {
    var existing =
      q(
        ".sparc-mobile-hero",
        panel
      );


    if (existing) {
      hero =
        existing;

      return hero;
    }


    hero =
      make(
        "section",
        "sparc-mobile-hero"
      );


    /* METRICS */

    var metrics =
      make(
        "div",
        "sparc-mobile-hero__metrics"
      );


    var priceMetric =
      make(
        "div",
        "sparc-mobile-hero__metric"
      );


    priceMetric.dataset.metric =
      "price";


    priceMetric.appendChild(
      make(
        "span",
        "sparc-mobile-hero__metric-label",
        "Configured Price"
      )
    );


    var priceValue =
      make(
        "strong",
        "sparc-mobile-hero__metric-value",
        configuredPrice()
      );


    priceValue.dataset.role =
      "price";


    priceMetric.appendChild(
      priceValue
    );


    var leadMetric =
      make(
        "div",
        "sparc-mobile-hero__metric"
      );


    leadMetric.dataset.metric =
      "lead";


    leadMetric.appendChild(
      make(
        "span",
        "sparc-mobile-hero__metric-label",
        "Est. Production"
      )
    );


    var leadValue =
      make(
        "strong",
        "sparc-mobile-hero__metric-value",
        leadText()
      );


    leadValue.dataset.role =
      "lead";


    leadMetric.appendChild(
      leadValue
    );


    metrics.appendChild(
      priceMetric
    );


    metrics.appendChild(
      leadMetric
    );


    /* BREADCRUMB */

    var breadcrumb =
      make(
        "div",
        "sparc-mobile-hero__breadcrumb"
      );


    var home =
      make(
        "a",
        "",
        "Home"
      );


    home.href =
      "/";


    breadcrumb.appendChild(
      home
    );


    breadcrumb.appendChild(
      make(
        "span",
        "",
        "›"
      )
    );


    var href =
      seriesHref();


    if (href) {
      var series =
        make(
          "a",
          "",
          currentSeriesName()
        );


      series.href =
        href;


      breadcrumb.appendChild(
        series
      );
    } else {
      breadcrumb.appendChild(
        make(
          "span",
          "",
          currentSeriesName()
        )
      );
    }


    breadcrumb.appendChild(
      make(
        "span",
        "",
        "›"
      )
    );


    breadcrumb.appendChild(
      make(
        "span",
        "sparc-mobile-hero__breadcrumb-current",
        productName()
      )
    );


    /* HERO BODY */

    var main =
      make(
        "div",
        "sparc-mobile-hero__main"
      );


    var copy =
      make(
        "div",
        "sparc-mobile-hero__copy"
      );


    copy.appendChild(
      make(
        "span",
        "sparc-mobile-hero__eyebrow",
        "CUSTOM CONFIGURATOR"
      )
    );


    var titleGroup =
      make(
        "div",
        "sparc-mobile-hero__title-group"
      );


    /*
      Build Your
      Flux

      Product name deliberately gets its own line.
    */

    var title =
      make(
        "h1",
        "sparc-mobile-hero__title"
      );


    title.appendChild(
      make(
        "span",
        "sparc-mobile-hero__title-prefix",
        "Build Your"
      )
    );


    title.appendChild(
      make(
        "span",
        "sparc-mobile-hero__title-product",
        productName()
      )
    );


    titleGroup.appendChild(
      title
    );


    titleGroup.appendChild(
      make(
        "div",
        "sparc-mobile-hero__rule"
      )
    );


    var detailsPill =
      make(
        "button",
        "sparc-mobile-hero__details-pill",
        "Product Details"
      );


    detailsPill.type =
      "button";


    detailsPill.addEventListener(
      "click",
      showDetails
    );


    titleGroup.appendChild(
      detailsPill
    );


    copy.appendChild(
      titleGroup
    );


    var media =
      make(
        "div",
        "sparc-mobile-hero__media"
      );


    var sourceImage =
      findHeroImage();


    if (sourceImage) {
      var image =
        make(
          "img",
          "sparc-mobile-hero__image"
        );


      image.alt =
        sourceImage.alt ||
        productName();


      image.src =
        sourceImage.currentSrc ||
        sourceImage.src;


      media.appendChild(
        image
      );
    }


    main.appendChild(
      copy
    );


    main.appendChild(
      media
    );


    hero.appendChild(
      metrics
    );


    hero.appendChild(
      breadcrumb
    );


    hero.appendChild(
      main
    );


    if (
      appbar.nextSibling
    ) {
      panel.insertBefore(
        hero,
        appbar.nextSibling
      );
    } else {
      panel.appendChild(
        hero
      );
    }


    return hero;
  }


  /* ==========================================================
     DESCRIPTION VIEW
     ========================================================== */

  function ensureDescriptionView() {
    var existing =
      q(
        ".sparc-mobile-description-view",
        panel
      );


    if (existing) {
      descriptionView =
        existing;

      return descriptionView;
    }


    descriptionView =
      make(
        "section",
        "sparc-mobile-description-view"
      );


    var content =
      make(
        "div",
        "sparc-mobile-description-view__content"
      );


    var source =
      findDescriptionSource();


    if (source) {
      var clone =
        source.cloneNode(
          true
        );


      clone.removeAttribute(
        "id"
      );


      content.appendChild(
        clone
      );
    } else {
      var meta =
        q(
          'meta[name="description"]'
        );


      if (
        meta &&
        meta.content
      ) {
        content.appendChild(
          make(
            "p",
            "",
            meta.content
          )
        );
      }
    }


    descriptionView.appendChild(
      content
    );


    var back =
      make(
        "button",
        "sparc-mobile-description-view__back",
        "Back to Configurator"
      );


    back.type =
      "button";


    back.addEventListener(
      "click",
      showConfigurator
    );


    descriptionView.appendChild(
      back
    );


    var list =
      q(
        ".sparc-accordion-list",
        panel
      );


    if (list) {
      panel.insertBefore(
        descriptionView,
        list
      );
    } else {
      panel.appendChild(
        descriptionView
      );
    }


    return descriptionView;
  }


  /* ==========================================================
     DETAILS MODE
     ========================================================== */

  function updateModeButton() {
    if (!appbar) {
      return;
    }


    var button =
      q(
        ".sparc-mobile-appbar__mode",
        appbar
      );


    if (!button) {
      return;
    }


    var details =
      panel.classList.contains(
        "sparc-mobile-mode-details"
      );


    var desired =
      details
        ?
        "BUILD"
        :
        "DETAILS";


    if (
      button.textContent !==
      desired
    ) {
      button.textContent =
        desired;
    }


    button.classList.toggle(
      "is-details",
      details
    );


    if (dock) {
      dock.classList.toggle(
        "is-details",
        details
      );
    }
  }


  function showDetails() {
    if (!panel) {
      return;
    }


    ensureDescriptionView();


    configScrollPosition =
      panel.scrollTop;


    panel.classList.add(
      "sparc-mobile-mode-details"
    );


    updateModeButton();


    panel.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }


  function showConfigurator() {
    if (!panel) {
      return;
    }


    panel.classList.remove(
      "sparc-mobile-mode-details"
    );


    updateModeButton();


    window.setTimeout(
      function () {
        panel.scrollTo({
          top:
            Math.max(
              0,
              configScrollPosition
            ),
          behavior:
            "smooth"
        });
      },
      40
    );
  }


  function toggleMode() {
    if (
      panel.classList.contains(
        "sparc-mobile-mode-details"
      )
    ) {
      showConfigurator();
    } else {
      showDetails();
    }
  }


  /* ==========================================================
     GRID LAYOUT
     ========================================================== */

  function decorateGrids() {
    if (!panel) {
      return;
    }


    var grids =
      qa(
        ".sparc-card-grid," +
        ".sparc-card-grid--2," +
        ".sparc-card-grid--3",
        panel
      );


    var knownClasses = [
      "sparc-mobile-grid-count-1",
      "sparc-mobile-grid-count-2",
      "sparc-mobile-grid-count-3",
      "sparc-mobile-grid-count-4",
      "sparc-mobile-grid-count-many"
    ];


    grids.forEach(
      function (grid) {
        var cards =
          Array.prototype.filter.call(
            grid.children,
            function (element) {
              return (
                element.classList &&
                element.classList.contains(
                  "sparc-option-card"
                )
              );
            }
          );


        var count =
          cards.length;


        var desired =
          "";


        if (
          count >= 1 &&
          count <= 4
        ) {
          desired =
            "sparc-mobile-grid-count-" +
            count;
        } else if (
          count > 4
        ) {
          desired =
            "sparc-mobile-grid-count-many";
        }


        if (!desired) {
          return;
        }


        if (
          grid.classList.contains(
            desired
          )
        ) {
          return;
        }


        knownClasses.forEach(
          function (className) {
            grid.classList.remove(
              className
            );
          }
        );


        grid.classList.add(
          desired
        );
      }
    );
  }


  /* ==========================================================
     SPARC LOGO = INCLUDED
     ========================================================== */

  function decorateIncludedCards() {
    if (!panel) {
      return;
    }


    qa(
      ".sparc-option-card",
      panel
    ).forEach(
      function (card) {
        var nameNode =
          q(
            ".sparc-option-card__name",
            card
          );


        var name =
          normalize(
            nameNode &&
            nameNode.textContent
          );


        var value =
          normalize(
            card.getAttribute(
              "data-value"
            )
          );


        var standardLogo =
          (
            name ===
            "sparclogo"
          )
          ||
          (
            value ===
            "sparclogo"
          );


        if (!standardLogo) {
          return;
        }


        var price =
          q(
            ".sparc-option-card__price",
            card
          );


        if (
          price &&
          clean(
            price.textContent
          ) !==
          "Included"
        ) {
          price.textContent =
            "Included";
        }


        if (
          !card.classList.contains(
            "sparc-mobile-horn-included"
          )
        ) {
          card.classList.add(
            "sparc-mobile-horn-included"
          );
        }
      }
    );
  }


  function decorateCards() {
    decorateGrids();
    decorateIncludedCards();
  }


  /* ==========================================================
     ADD TO CART
     ========================================================== */

  function findRealAddToCart() {
    var direct =
      q(
        'form[action*="/cart/add"] button[name="add"],' +
        'form[action*="/cart/add"] input[name="add"]'
      );


    if (direct) {
      return direct;
    }


    var controls =
      qa(
        'button,input[type="submit"],a'
      );


    return controls.find(
      function (node) {
        if (
          node.classList &&
          node.classList.contains(
            "sparc-mobile-dock__action"
          )
        ) {
          return false;
        }


        var text =
          clean(
            (node.textContent || "")
            +
            " "
            +
            (node.value || "")
          ).toLowerCase();


        return (
          /add\s+to\s+cart/
            .test(
              text
            )
          ||
          (
            node.getAttribute &&
            node.getAttribute(
              "name"
            ) ===
            "add"
          )
        );
      }
    ) || null;
  }


  /* ==========================================================
     BOTTOM DOCK
     ========================================================== */

  function ensureDock() {
    var existing =
      q(
        ".sparc-mobile-series-dock"
      );


    if (existing) {
      dock =
        existing;

      return dock;
    }


    dock =
      make(
        "div",
        "sparc-mobile-dock sparc-mobile-series-dock"
      );


    var priceWrap =
      make(
        "div",
        "sparc-mobile-dock__price"
      );


    priceWrap.appendChild(
      make(
        "span",
        "sparc-mobile-dock__label",
        "Configured Price"
      )
    );


    priceWrap.appendChild(
      make(
        "strong",
        "sparc-mobile-dock__value",
        configuredPrice()
      )
    );


    var action =
      make(
        "button",
        "sparc-mobile-dock__action",
        "NEXT STEP"
      );


    action.type =
      "button";


    action.addEventListener(
      "click",
      function () {
        if (
          currentIsFinal()
        ) {
          var add =
            findRealAddToCart();


          if (add) {
            add.click();
          }


          return;
        }


        var next =
          nextSection();


        if (!next) {
          return;
        }


        var header =
          q(
            ".sparc-accordion__head",
            next
          );


        if (!header) {
          return;
        }


        /*
          Trigger the REAL Driver / Heritage / Classic /
          Garage accordion control.
        */

        header.click();


        window.setTimeout(
          function () {
            scrollSection(
              next
            );
          },
          90
        );
      }
    );


    dock.appendChild(
      priceWrap
    );


    dock.appendChild(
      action
    );


    document.body.appendChild(
      dock
    );


    return dock;
  }


  /* ==========================================================
     SCROLL
     ========================================================== */

  function scrollSection(node) {
    if (
      !panel ||
      !node
    ) {
      return;
    }


    var panelRect =
      panel.getBoundingClientRect();


    var nodeRect =
      node.getBoundingClientRect();


    var headerHeight =
      appbar
        ?
        appbar.offsetHeight
        :
        58;


    var destination =
      panel.scrollTop
      +
      (
        nodeRect.top -
        panelRect.top
      )
      -
      headerHeight
      -
      8;


    panel.scrollTo({
      top:
        Math.max(
          0,
          destination
        ),
      behavior:
        "smooth"
    });
  }


  /* ==========================================================
     ANIMATION
     ========================================================== */

  function restartClass(
    node,
    className,
    duration
  ) {
    if (!node) {
      return;
    }


    node.classList.remove(
      className
    );


    void node.offsetWidth;


    node.classList.add(
      className
    );


    window.setTimeout(
      function () {
        node.classList.remove(
          className
        );
      },
      duration
    );
  }


  /* ==========================================================
     VALUE SYNC
     ========================================================== */

  function updateValues() {
    var nextPrice =
      configuredPrice();


    var nextLead =
      leadText();


    if (hero) {
      var heroPrice =
        q(
          '[data-role="price"]',
          hero
        );


      var heroLead =
        q(
          '[data-role="lead"]',
          hero
        );


      if (
        heroPrice &&
        clean(
          heroPrice.textContent
        ) !==
        nextPrice
      ) {
        heroPrice.textContent =
          nextPrice;
      }


      if (
        heroLead &&
        clean(
          heroLead.textContent
        ) !==
        nextLead
      ) {
        heroLead.textContent =
          nextLead;
      }
    }


    if (dock) {
      var dockPrice =
        q(
          ".sparc-mobile-dock__value",
          dock
        );


      if (
        dockPrice &&
        clean(
          dockPrice.textContent
        ) !==
        nextPrice
      ) {
        dockPrice.textContent =
          nextPrice;
      }
    }


    if (!firstValueSync) {
      if (
        nextPrice &&
        nextPrice !==
        "—"
        &&
        lastPrice
        &&
        nextPrice !==
        lastPrice
      ) {
        if (hero) {
          restartClass(
            q(
              '[data-role="price"]',
              hero
            ),
            "sparc-mobile-price-change-active",
            760
          );
        }


        if (dock) {
          restartClass(
            q(
              ".sparc-mobile-dock__value",
              dock
            ),
            "sparc-mobile-price-change-active",
            760
          );
        }
      }


      if (
        nextLead &&
        nextLead !==
        "—"
        &&
        lastLead
        &&
        nextLead !==
        lastLead
      ) {
        if (hero) {
          restartClass(
            q(
              '[data-metric="lead"]',
              hero
            ),
            "sparc-mobile-production-change-active",
            2750
          );
        }
      }
    }


    if (
      nextPrice &&
      nextPrice !==
      "—"
    ) {
      lastPrice =
        nextPrice;
    }


    if (
      nextLead &&
      nextLead !==
      "—"
    ) {
      lastLead =
        nextLead;
    }


    firstValueSync =
      false;
  }


  function updateDockButton() {
    if (!dock) {
      return;
    }


    var action =
      q(
        ".sparc-mobile-dock__action",
        dock
      );


    if (!action) {
      return;
    }


    var desired =
      currentIsFinal()
        ?
        "ADD TO CART"
        :
        "NEXT STEP";


    if (
      action.textContent !==
      desired
    ) {
      action.textContent =
        desired;
    }
  }


  /* ==========================================================
     LOADING LOGO
     ========================================================== */

  function ensureLoadingLogo() {
    var loader =
      document.getElementById(
        "sparc-configurator-loader"
      );


    if (!loader) {
      return;
    }


    if (
      q(
        ".sparc-mobile-loading-logo",
        loader
      )
    ) {
      return;
    }


    var source =
      findLogoNode();


    if (!source) {
      return;
    }


    var holder =
      make(
        "div",
        "sparc-mobile-loading-logo"
      );


    var clone =
      source.cloneNode(
        true
      );


    clone.removeAttribute(
      "id"
    );


    if (
      clone.removeAttribute
    ) {
      clone.removeAttribute(
        "width"
      );

      clone.removeAttribute(
        "height"
      );
    }


    holder.appendChild(
      clone
    );


    loader.appendChild(
      holder
    );
  }


  /* ==========================================================
     CLEAN OLD ADAPTER UI
     ========================================================== */

  function cleanOldSeriesMobileDom() {
    if (!panel) {
      return;
    }


    [
      ".sparc-mobile-appbar",
      ".sparc-mobile-hero",
      ".sparc-mobile-description-view"
    ].forEach(
      function (selector) {
        qa(
          selector,
          panel
        ).forEach(
          function (node) {
            node.remove();
          }
        );
      }
    );


    qa(
      ".sparc-mobile-series-dock"
    ).forEach(
      function (node) {
        node.remove();
      }
    );
  }


  /* ==========================================================
     SYNC

     No MutationObserver.
     This avoids the feedback loop that froze Driver.
     ========================================================== */

  function syncAll() {
    if (
      syncing ||
      !panel ||
      !isPhone()
    ) {
      return;
    }


    syncing =
      true;


    try {
      updateValues();
      updateDockButton();
      updateModeButton();
      updateCartCount();
      decorateCards();
      ensureLoadingLogo();
    } finally {
      syncing =
        false;
    }
  }


  function scheduleSync() {
    window.clearTimeout(
      syncTimer
    );


    syncTimer =
      window.setTimeout(
        syncAll,
        80
      );
  }


  /* ==========================================================
     EVENTS
     ========================================================== */

  function installEvents() {
    if (
      eventsInstalled ||
      !panel
    ) {
      return;
    }


    eventsInstalled =
      true;


    /*
      LISTEN ONLY.
      Do not prevent or replace configurator events.
    */

    panel.addEventListener(
      "click",
      scheduleSync,
      true
    );


    panel.addEventListener(
      "change",
      scheduleSync,
      true
    );


    panel.addEventListener(
      "input",
      scheduleSync,
      true
    );


    document.addEventListener(
      "change",
      scheduleSync,
      true
    );
  }


  /* ==========================================================
     LOW-FREQUENCY BACKUP SYNC
     ========================================================== */

  function installBackupSync() {
    if (syncInterval) {
      window.clearInterval(
        syncInterval
      );
    }


    syncInterval =
      window.setInterval(
        function () {
          if (
            panel &&
            isPhone()
          ) {
            syncAll();
          }
        },
        700
      );
  }


  /* ==========================================================
     ACTIVATE
     ========================================================== */

  function activate() {
    if (!isPhone()) {
      return false;
    }


    /*
      HARD SAFETY BARRIER.

      If the standard Muscle configurator exists,
      this file exits and Muscle V4 owns the page.
    */

    if (
      document.getElementById(
        "sparc-muscle-configurator"
      )
    ) {
      return false;
    }


    panel =
      getPanel();


    if (!panel) {
      return false;
    }


    cleanOldSeriesMobileDom();


    document.documentElement
      .classList.add(
        "sparc-mobile-app-active"
      );


    document.body
      .classList.add(
        "sparc-mobile-app-active"
      );


    document.body
      .classList.add(
        "sparc-mobile-series-active"
      );


    panel.classList.add(
      "sparc-mobile-app-panel"
    );


    panel.classList.add(
      "sparc-mobile-series-root"
    );


    panel.classList.remove(
      "sparc-mobile-mode-details"
    );


    panel.setAttribute(
      "data-sparc-mobile-series",
      currentSeriesName()
    );


    markAncestors();


    ensureAppBar();
    ensureHero();
    ensureDescriptionView();
    ensureDock();


    decorateCards();
    ensureLoadingLogo();


    installEvents();
    installBackupSync();


    syncAll();


    window.setTimeout(
      syncAll,
      150
    );


    window.setTimeout(
      syncAll,
      400
    );


    window.setTimeout(
      syncAll,
      900
    );


    console.info(
      "[SPARC MOBILE SERIES V1 FIXED] Active:",
      panel.id,
      currentSeriesName()
    );


    return true;
  }


  /* ==========================================================
     START
     ========================================================== */

  function start() {
    if (!isPhone()) {
      return;
    }


    var attempts =
      0;


    var timer =
      window.setInterval(
        function () {
          attempts++;


          if (
            activate()
            ||
            attempts >=
            100
          ) {
            window.clearInterval(
              timer
            );
          }
        },
        250
      );
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }

})();